import {User} from "../../data-access/api-users/User";

export class AuthUtil {
  public static User(user: User): User {
    return user.userEmail
      ? user
      : User.ANONYMOUS
  }
}
